export default __webpack_public_path__ + "static/media/construct.3a03eaa1.svg";